import { AppRoutingModule } from './app-routing.module';
import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProfileModule } from './modules/profile/profile.module';
import { PageNotFoundModule } from './modules/page-not-found/page-not-found.module';
import { RegisterModule } from './modules/register/register.module';
import { AnalyticsService } from './providers/analytics/analytics.service';
import { AnalyticsComponent } from './modules/analytics/analytics.component';
import { GraphqlModule } from './providers/graphql/graphql.module';
import { LayoutModule } from './modules/layout/layout.module';
import { AuthModule } from './modules/auth/auth.module';
import { ModalModule } from './modules/modal/modal.module';
import { MediaModule } from './modules/media/media.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { SignalModule } from './modules/signal/signal.module';
import { AppointmentModule } from './modules/appointment/appointment.module';
import { WebrtcModule } from './modules/webrtc/webrtc.module';
import { ConferenceModule } from './modules/conference/conference.module';
import { CountdownModule } from './modules/countdown/countdown.module';
import { CookieModule } from 'ngx-cookie';
import { RtcDetectionModule } from './modules/rtc-detection/rtc-detection.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EmailModule } from './modules/email/email.module';
import { SettingModule } from './modules/setting/setting.module';
import { TagInputModule } from 'ngx-chips';
import { PreInitConditionModule } from './modules/pre-init-condition/pre-init-condition.module';
import { LogAppointmentModule } from './modules/logging/log-appointment.module';
import { BrandingModule } from './modules/branding/branding.module';
import { PagesModule } from './pages/pages.module';
import { PaymentPayOutModule } from './entities/payment-pay-out/payment-pay-out.module';
import { SpecialityModule } from './entities/speciality/speciality.module';
import { PaymentCountryModule } from './entities/payment-country/payment-country.module';
import { PaymentInfoModule as PaymentInfoEntityModule } from './entities/payment-info/payment-info.module';
import { SurveyModule } from './entities/survey/survey.module';
import { MessageBusModule } from './modules/message-bus/message-bus.module';
import { FileTransferModule } from './modules/file-transfer/file-transfer.module';
import { LegalModule } from './modules/legal/legal.module';
import { LoadingSpinnerModule } from './loading-spinner/loading-spinner.module';
import { WebrtcConnectionStatsModule } from './entities/webrtc-connection-stats/webrtc-connection-stats.module';
import { UtilsModule } from './modules/utils/utils.module';
import { AppStoreModule } from './providers/store/store.module';
import { UserPresenceModule } from './modules/user-presence/user-presence.module';
import { JitsiModule } from './modules/jitsi/jitsi.module';
import { ConferenceV2Module } from './modules/conference-v2/conference-v2.module';
import { UserAgentModule } from './modules/user-agent/user-agent.module';
import { InstitutionSettingsModule } from './modules/institution-settings/institution-settings.module';
import { CustomErrorHandlerModule } from './modules/custom-error-handler/custom-error-handler.module';
import { environment } from '../environments/environment';
import { TranslateHttpLoaderFactory } from './providers/translate/factories/translate-http-loader.factory';
import { TranslateModule as CustomTranslateModule } from './providers/translate/translate.module';

// @ts-ignore
// @ts-ignore
@NgModule({
    declarations: [
        AppComponent,
        AnalyticsComponent
    ],
    imports: [
        BrandingModule,
        BrowserModule,
        BrowserAnimationsModule,
        // @FIXIT:Because module dependency issues we have to import this third party module global. Please fix it
        AppStoreModule,
        AuthModule,
        NgbModule,
        NgxPermissionsModule.forRoot(),
        RegisterModule,
        PageNotFoundModule,
        ProfileModule,
        AppointmentModule,
        ConferenceModule,
        ConferenceV2Module,
        AppRoutingModule,
        HttpClientModule,
        LayoutModule,
        GraphqlModule,
        ModalModule,
        MediaModule,
        SignalModule,
        WebrtcModule,
        EmailModule,
        SettingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: TranslateHttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        CountdownModule.forRoot(),
        CookieModule.forRoot(),
        RtcDetectionModule.forRoot(),
        TagInputModule,
        PreInitConditionModule,
        LogAppointmentModule,
        PagesModule,
        SpecialityModule,
        PaymentInfoEntityModule,
        PaymentCountryModule,
        PaymentPayOutModule,
        SurveyModule,
        MessageBusModule,
        FileTransferModule,
        LegalModule,
        LoadingSpinnerModule,
        WebrtcConnectionStatsModule,
        UtilsModule,
        JitsiModule,
        UserPresenceModule,
        UserAgentModule,
        InstitutionSettingsModule,
        CustomErrorHandlerModule.forRoot(environment.production),
        CustomTranslateModule
    ],
    providers: [
        AnalyticsService,
        Title
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
